import React from 'react';
import { useGetAppointmentTypes } from '../../../App/customize/hooks/useGetAppointmentTypes';
import { useAppointmentLabels } from '../../../App/customize/hooks/useAppointmentLabels';

export function AppointmentInfo({ appointmentInfo }) {
  const { data: appointmentTypes = [] } = useGetAppointmentTypes();
  const labels = useAppointmentLabels();

  const labelName = {
    dateTime: 'Date and Time',
    type: labels.appointmentType,
    doctor: 'Doctor',
  };

  return (
    <div className="modal-main-info-data of-appointment">
      {Object.entries(appointmentInfo).map(([key, value]) => {
        const label = labelName[key];
        let dataToShow = value;

        if (key === 'id') return null;

        if (key === 'dateTime') {
          dataToShow = `${value.date} ${value.time}`;
        }
        if (key === 'type') {
          dataToShow =
            appointmentTypes.find(({ _id }) => _id === value)?.title || value;
        }

        return (
          <div
            key={key}
            className={`${key} modal-main-info-field`}
            style={{ gridArea: key }}
          >
            <p className="field-label">{label}</p>
            <p
              className="field-data text-capitalize ellipsis"
              title={dataToShow}
            >
              {dataToShow}
            </p>
          </div>
        );
      })}
    </div>
  );
}
